<div *ngIf="registration != undefined"
      (click)="showList = false; $event.stopPropagation();"
      class="col-md-12 mb-3">
    <div class="row">
        <div class="col-12">
            <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
            <div class="list-title d-flex">
                <span class="d-flex w-50 pr-1 title">
                    {{ 'Laws' | translate }} ({{registrationLawListLength ? registrationLawListLength : '0'}})
                </span>
            </div>
            <div class="row p-0 m-0 page-table">
                <div class="list-group-collapse single flex-wrap col-md-6 px-0"
                     cdkDropList
                      [cdkDropListData]="registrationLawList"
                      (cdkDropListDropped)="dropped($event)">
                    <div cdkDrag *ngFor="let registrationLaw of registrationLawList; let first = first; let last = last"
                         class="{{ disabled ? 'list-item-disabled' : 'list-item' }} w-100 {{first ? 'first' : ''}}">
                        <div (click)="openEdit(registrationLaw);$event.stopPropagation();"
                             class="list-item-element d-flex justify-content-between pr-3">
                            <div class="d-flex justify-content-between w-100">
                                <div class="d-flex align-items-center w-100">
                                    <div>{{registrationLaw.law.name | translate}}</div>
                                </div>
                                <div class="d-flex align-items-center" *ngIf="!disabled">
                                    <confirmation [showTrashIcon]="true"
                                                  [question]="'confirm.areyousure'"
                                                  [extraClasses]="'d-flex'"
                                                  (click)="$event.stopPropagation();"
                                                  (isConfirmed)="deleteLaw($event, registrationLaw.id)">
                                    </confirmation>
                                </div>
                            </div>
                        </div>
                        <div *cdkDragPreview class="col-4">
                            <div>
                                {{registrationLaw.law.name | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="w-100" style="position:relative;" *ngIf="!disabled">
                        <div class="list-item w-100 last add-item {{showList ? 'opened' : ''}}"
                             (click)="showOrAdd(); $event.stopPropagation();">
                            <div class="d-flex w-100 justify-content-between pr-3 list-itemPart first">
                                <div class="{{showList ? 'hidden' : ''}}">
                                    <span *ngIf="laws?.length > 0 && registrationLawListLength != laws?.length"><i class="fal fa-plus"></i> {{'Select or add new' | translate}}</span>
                                    <span *ngIf="laws?.length == 0 || registrationLawListLength == laws?.length"><i class="fal fa-plus"></i> {{'Add new' | translate}}</span>
                                </div>
                                <input (input)="searchLawChanged($event.target.value)" (click)="$event.stopPropagation();" placeholder="{{ 'Search' | translate }}" type="text" class="{{showList ? '' : 'hidden'}} select-search" />
                                <span (click)="openEdit(false);$event.stopPropagation();"
                                       class="addBtn lower services-icon--add ml-auto {{showList ? '' : 'hidden'}}">{{'Add' | translate}}</span>
                            </div>
                        </div>
                        <div class="w-100 list-item-group limit-height-200 vertical-scroll" *ngIf="laws?.length > 0">
                          <div *ngFor="let law of laws | filterBy: searchLawFilter; let first = first; let last = last; let i = index">
                            <div *ngIf="showLaws[law.id]"
                                  (click)="addRegistrationLaw(law);$event.stopPropagation();"
                                  class="list-item w-100 select-item {{showList ? '' : 'hidden'}} {{last ? 'last' : ''}}">
                                <div class="d-flex justify-content-between pr-3 list-itemPart first">
                                    <div class="d-flex align-items-center w-100">
                                        <div>{{law.name}}</div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
